export default __webpack_public_path__ + "static/media/banner-desktop.c273f96f.jpg";